import React from 'react';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { useDefaultQueryFields } from '../order.effect';

const GroupChatPendingList: React.FC = () => {
  const tabScene = OrderTabScene.GroupGroupChat;
  const queryFields = useDefaultQueryFields(tabScene);

  const renderTableActions = (order: MergedOrder, context?: any) => {
    const sceneKey = context?.scene || tabScene;
    const targets: OrderTriggerTarget[] = [];

    if (sceneKey === 'tab_group_chat_pending') {
      targets.push('markGroupChatCreated');
    }

    return <OrderTriggerActionMap layout="table" targets={targets} order={order} />;
  };

  return (
    <OrderTriggerActionProvider>
      <OrderListTemplate
        tabScene={tabScene}
        defaultScene='tab_group_chat_pending'
        queryFields={queryFields}
        viewModes={[
          {
            mode: 'table',
            label: '列表页',
            showField: 'groupChatPending',
            renderActions: renderTableActions,
          },
        ]}
      />
    </OrderTriggerActionProvider>
  );
};

export default GroupChatPendingList;
